export default __webpack_public_path__ + "static/media/t_twitter.2c115f9a.png";